"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeaconUpdatesWithSignedData__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "beaconSetId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        name: "UpdatedBeaconSetWithBeacons",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "beaconId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        name: "UpdatedBeaconWithSignedData",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "containsBytecode",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockBasefee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "tryMulticall",
        outputs: [
            {
                internalType: "bool[]",
                name: "successes",
                type: "bool[]",
            },
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32[]",
                name: "beaconIds",
                type: "bytes32[]",
            },
        ],
        name: "updateBeaconSetWithBeacons",
        outputs: [
            {
                internalType: "bytes32",
                name: "beaconSetId",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "airnode",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "templateId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "updateBeaconWithSignedData",
        outputs: [
            {
                internalType: "bytes32",
                name: "beaconId",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class BeaconUpdatesWithSignedData__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.BeaconUpdatesWithSignedData__factory = BeaconUpdatesWithSignedData__factory;
//# sourceMappingURL=BeaconUpdatesWithSignedData__factory.js.map